import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Create a separate API for OTP endpoints
export const otpApi = createApi({
  reducerPath: "otpApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_BACKEND_BASE_URL,
  }),
  tagTypes: ["Otp"],
  endpoints: () => ({}),
});
